export default {
  fontTitle: "科博留学剑桥监护中心-始于 2002，致力于专业、可信的英国教育导航",
  fontDesc: "",
  blog: "博客",
  more: "查看全部",
  readMore: "查看更多",
  backToBlog: "返回博客",
  blogConsult: "立即咨询",
  blogConsultText: "你的孩子也需要这样的成长引路人吗？",
  blogConsultText2: "预约Clare一对一咨询",
  meticulousCare: {
    label: "品牌故事",
    title: "我们的监护理念",
    desc: "我们的使命是为每一位留学生找到最契合的学校，提供贴心且安心的监护服务，让家庭放心，让孩子健康成长。",
    learnMore: "了解更多",
  },
  blogList: [
    {
      img: require("@/assets/images/blog/blog1.png"),
      date: "2025年06月",
      title:
        "跨越十年的守护：\n从语言学校到帝国理工，一位监护人与学生的双赢旅程",
      desc: "",
    },
    {
      img: require("@/assets/images/blog/blog2.png"),
      date: "2024年07月",
      title: "教育无边界：\nClare荣获UKCWC杰出贡献奖背后的守护故事",
      desc: "",
    },
    {
      img: require("@/assets/images/blog/blog3.png"),
      date: "2023年07月",
      title: "科博国际教育\n点亮星灯暑期自闭症活动",
      desc: "",
    },
    {
      img: require("@/assets/images/blog/blog4.png"),
      date: "2024年09月",
      title: "从牛津到顶尖律所：\n我的女儿Katerina",
      desc: "",
    },
    {
      img: require("@/assets/images/blog/blog5.png"),
      date: "2017年07月",
      title: "从剑桥梦到科技金融：\n一位学霸的跨领域成长之旅",
      desc: "",
    },
    {},
  ],
  guardianBgRows: [
    {
      year: "2001",
      event: "缘起",
      desc: "因一位中国挚友的请托，我首次踏入国际教育领域。她希望将9岁和15岁的儿子送往英国求学，为他们争取更美好的未来。我深入研究英国私立学校体系，成功协助他们入读合适的寄宿学校，并成为孩子们在英国的法定监护人。",
    },
    {
      year: "2002",
      event: "创立教育咨询事业",
      desc: "2002年末，次女出生后，我辞去伦敦NHS的工作，全心投入国际学生择校与监护服务事业，专注为海外家庭提供专业支持。",
    },
    {
      year: "2017",
      event: "侄女剑桥圆梦",
      desc: "2005年，9岁的侄女首次访问剑桥，种下了剑桥求学梦。九年后，她如愿成为剑桥大学经济学本科新生。",
    },
    {
      year: "2023",
      event: "女儿牛津毕业",
      desc: "女儿自牛津大学法学院毕业，随后加入顶尖国际律师事务所，开启职业生涯。",
    },
    {
      year: "2024",
      event: "英国华人女性联盟荣誉",
      desc: "因在支持弱势家庭以及为来自战乱国家的难民提供免费专业服务等方面表现出的卓越奉献精神，荣获英国华人女性联合会（UKCWC）颁发的杰出贡献奖。",
    },
  ],
  // 家长专区FAQ
  parentFaqList: [
    {
      number: "01",
      question: "我的孩子几岁可以申请英国私立学校？",
      answer:
        "通常，英国私立学校接收从7岁到18岁的学生。根据孩子的英语水平和学术能力，我们会协助推荐适合的入学年级与学校类型。",
    },
    {
      number: "02",
      question: "学校申请流程是怎样的？",
      answer: "",
    },
    {
      number: "03",
      question: "如果孩子英语不好，还可以申请吗？",
      answer: "",
    },
    {
      number: "04",
      question: "什么是监护人服务？为什么必须要有监护人？",
      answer: "",
    },
    {
      number: "05",
      question: "放假期间孩子可以回国吗？",
      answer: "",
    },
    {
      number: "06",
      question: "您的监护服务有哪些特色？",
      answer: "",
    },
    {
      number: "07",
      question: "可以只做学校申请，不要监护服务吗？",
      answer: "",
    },
    {
      number: "08",
      question: "我们已经自己申请好学校了，可以只委托您做监护吗？",
      answer: "",
    },
  ],

  nav: {
    logo: "环球留学",
    home: "首页",
    services: "服务",
    story: "品牌故事",
    testimonials: "客户感言",
    parents: "FAQs",
    "Cambridge HOPE Guardianship": "科博留学剑桥监护中心",
    brand: "科博留学剑桥监护中心",
    blog: "博客",
    contact: "立即咨询",
    languageChanged: "语言切换成功",
    policies: "隐私政策",
  },
  cookie: {
    message:
      "为优化您的浏览体验，本网站使用Cookie记录访问行为（如页面停留时间、点击热点等）。继续访问即表示您理解并接受此做法。",
    privacy: "隐私政策",
    accept: "接受",
    reject: "拒绝",
  },
  practice: {
    title1: "始于2002，",
    title2: "致力于专业、可信的",
    title22: "英国教育导航",
    title3: "我们提供个性化需求定制：",
    title4: "专业监护计划",
    title5: "寄宿学校择校指导",
    title6: "全流程入学申请导航",
    title7: "（具体服务等级将在咨询后为您定制）",
    wechatContent: "扫码添加微信",
  },
  home: {
    cardTitles: {
      card0: {
        title: "AEGIS金牌监护人",
        subtitle: "监护行业的权威标准",
        desc: "英国唯一独立认证的监护机构质量评估组织",
        note: "",
      },
      card1: {
        title: "妈妈级别的学业守护",
        subtitle: "从择校到选课",
        desc: "关注每个学术细节——每学期亲赴学校面对面沟通",
      },
      card2: {
        title: "紧急事件",
        subtitle: "快速支援服务",
        desc: "全天候本地应急支持，无时区障碍",
      },
      card3: {
        title: "家的温暖--",
        subtitle: "警局背景审查合格的\n寄宿家庭",
        desc: "严格筛选的本地家庭 ——让孩子每个假期都倍感温暖 ",
      },
      // card4: {
      //   title: "成长理财课",
      //   subtitle: "零花钱到学费管理",
      //   desc: "银行开户与财务托管协助服务",
      // },
    },
    customerTestimonialsDesc2: "客户对我们的评价",
    customerTestimonialsLearnMore: "更多评价",
    wechatContent: "扫码添加微信",
    customerTestimonialsTitle: "客户感言",
    customerTestimonialsDesc: "来自监护案例的真实反馈",

    customerTestimonialsList: [
      {
        img: require("@/assets/images/custom1.png"),
        user: "沈宜父亲",
        school: " 其女儿曾就读于Woodbridge School，目前就读于爱丁堡大学经济专业。",
        desc: "Clare好！\n\n回望孩子在您监护下的岁月，心中满是感激和钦佩，都说“儿行千里母担忧”，幸而有您的专业和热心，支持她适应异域环境，帮助她克服生活困难，指导她规划深造之路，促进她顺利考入心仪的大学。\n\n记得疫情期间，她无论在往返中英、学习秩序还是假期生活上都遭遇一系列的困难，而您总是当机立断、不顾安危、东奔西走协助处理，带着孩子一会穿越城市加急办理BRP卡，一会赴医院进行病情诊断，一会协调当地的寄宿……疫情三年，正在您的呵护下，孩子身心健康，学业顺利，获得了良好的成长环境。\n\n在成长教育上，您的干练、大方、雅致等为她做出优秀的榜样。您时常邀请她赴家中小憩，期间，细到怎样叠衣服、怎样理行李、怎样做饭菜？您都会手把手地教她独立生活的技能；同时还通过身边具体的事情，教导孩子要学会独立思考、勤俭持家和勇争上游，平等、坦率又不失权威的沟通甚于我们亲身父母。\n\n我们非常珍惜与您因孩子而结下的缘分，孩子念大学后，您继续给她细致的关心和帮助，特别是向她提供人生的建议，令我们颇感温暖，愿我们的友谊地久天长。 沈俊（沈宜父亲）",
      },
      {
        img: require("@/assets/images/custom2.png"),
        user: "Victoria  王馨桎家长",
        school:
          "其女儿曾就读于St Mary's School Cambridge，毕业于帝国理工学院生物化学专业，现已获得研究生录取通知书。",
        desc: "亲爱的Clare ：\n\n展信悦！\n\n今天有个朋友在咨询女儿出国的经历时，不由自主的谈到了您，问及您是怎样一个监护人时，我竟一时语塞，不知如何作答。朋友、母亲、老师，心理医生，知书达礼，温文尔雅......凡此种种不一而足。\n\n当年为了给女儿提供一个充满选择和可能性的未来，我们把12岁的女儿送到了英国求学。清楚的记得第一次见面时您把我们直接接回了家里，并准备了一桌丰盛的晚餐，一句“我们王家的女儿来了”，瞬间就让我们和孩子对未知的迷茫减轻了许多。\n\n是您耐心地陪着女儿度过人生中最重要的青春期阶段，同时让我们纵然远隔重洋都能随时见证她的成长和进步；是您想方设法地让女儿平稳地度过了初到异乡的心理以及生理的不适期，之后又鼓励和支持她选择了更好的学校；正是您的关爱和陪伴，女儿成长成为了一个有温度懂情趣会思考的人，学会了爱自己保护自己，也是您的言传身教，女儿明白了被需要、帮助别人是一件幸福的事情，懂得了怎么做一个有原则并且善良的女性......一切种种，汇集两字：感恩！\n\n我们非常欣慰的听到，女儿告诉我们，她想成为您这样的女性：拥有怜悯之心、助人之手、宽容之怀，美丽、自信和优雅，内心强大。\n\n以上啰嗦了这许多，却总觉得也还没说明白。但有一点可以明确的是：非常荣幸能有您这样的朋友，感恩您对我们所有的付出，我们也会将这份感恩传递。\n\n另：非常高兴的告诉您，女儿今年的已经顺利从帝国理工学院本科毕业，并拿到帝国理工学院研究生offer.\n\n顺颂时祺！秋绥冬禧！\n\n好友：王强、许菁",
      },
      {
        img: require("@/assets/images/custom3.png"),
        user: "王晟羽母亲",
        school:
          "其儿子曾在King's School Ely就读，后毕业于伦敦艺术学院，现任上市公司日播时尚集团董事长。",
        desc: "Clare是一位非常负责任且高效的学生监护人。在我儿子面临学校选择的重要时刻，她以专业的判断力和丰富的经验，给予了我们极具价值的建议，帮助我儿子顺利找到适合他的学校，让他重新建立起信心，走出了低谷。<br /><br />不仅如此，Clare 在整个过程中始终用心陪伴，不仅是孩子的支持者，也成为我的好朋友，她给了我太多细致入微的帮助，她的专业能力与真诚关怀，让人感到非常安心与信任。<br /><br />我衷心推荐Clare,她不仅是孩子成长路上的良师，更是家长可以全心依靠的伙伴。",
      },
    ],
    story: {
      title: "品牌故事",
      desc: "我们的监护理念",
      desc2:
        "我们的使命是为每一位留学生找到最契合的学校，提供贴心且安心的监护服务，让家庭放心，让孩子健康成长。",
      button: "了解更多",
    },
    godTitle: "金牌监护人背景",
    schoolFeedbackTitle: "舍监/学校反馈",
    schoolFeedbackTitle2: "来自官方的评价",
    schoolFeedback: [
      {
        icon: require("@/assets/images/schoolicon1.png"),
        school: "英国圣约瑟夫学院",
        author: "Alice Lee",
        title: "英国圣约瑟夫学院\n国际联络官",
        quote: [
          {
            line: "Clare女士作为英国监护人，在照料国际学生方面拥有丰富的专业知识与经验。",
          },
          {
            line: "我与她共事逾25载，钦佩其始终如一的专业素养——她确保每位受托学生都能获得最完善的成长支持。",
          },
          {
            line: "学生们总是期待她的校访，主动分享生活点滴。",
          },
          {
            line: "遇到困惑时，也乐于向她寻求建议并托付心事。",
          },
          {
            line: "作为同样肩负国际学生监护责任的同行，我毫无保留地向您推荐Clare。",
          },
        ],
      },
      {
        icon: require("@/assets/images/schoolicon2.png"),
        school: "",
        author: "Alan Robinson",
        title: "圣埃德蒙学院\n男生宿舍总监",
        quote: [
          {
            line: "我在担任圣埃德蒙学院男生宿舍舍监的十四年间认识了王女士（Clare Wang）。",
          },
          {
            line: "她极其可靠，始终将学生的需求和困难置于首位。",
          },
          {
            line: "她在处理日常事务、组织寄宿家庭以及安排旅行等具体事务方面的高效无与伦比。",
          },
          {
            line: "她也会出席每一次家长会，支持学生并在必要时鼓励他们取得更好的成绩。",
          },
          {
            line: "她总是那么友善、投入、乐于助人，并且在监护工作的各个方面都知识渊博。",
          },
        ],
      },
      {
        icon: require("@/assets/images/schoolicon3.png"),
        school: "英国知名学院",
        author: "Julian Baker",
        title:
          "瑞盖特文法学校（原Box Hill School）\n国际注册主任/IB协调员\n前国际中心主任、BAISIS协会主席",
        quote: [
          {
            line: "我有幸认识王女士（Clare Wang）超过二十年。",
          },
          {
            line: "在此期间，她始终如一的奉献精神及其在英国私立教育领域的专业知识，都给我留下了深刻的印象。",
          },
          {
            line: "她对全国各地的学校有着深入的了解，并且善于根据学生的需求将他们安置在最合适的院校，确保在学术和个人层面都匹配良好。",
          },
          {
            line: "王女士不仅是她所服务的家庭和学生的有力倡导者，同时也非常支持学校的工作。她保持着开放、有效的沟通，始终以学生的最大利益行事。",
          },
          {
            line: "她在学期初和学期末高效安排寄宿家庭和协调旅行计划的能力，反映了她致力于为所有相关人员创造尽可能顺畅体验的承诺。",
          },
          {
            line: "最重要的是，她坚定不移地致力于为她所服务的学生争取最佳成果，这一点尤为突出。"
          }
        ],
      },
    ],
    banner: {
      title1: "始于2002，",
      title2: "致力于专业、可信的",
      title3: "英国教育导航",
      desc1:
        "我们提供全方位的留学咨询、申请指导、签证服务，助你顺利踏上留学之路",
      button1: "了解服务",
      desc2: "美国、英国、加拿大、澳大利亚等热门留学国家，专业团队为你保驾护航",
      button2: "查看国家",
      ask: "立即咨询",
      Evaluation: "免费评估",
    },
    whoWeAre: {
      containerTitle: "家长可能关心的事",
      containerDesc: "联系我们获得更多信息",
      containerBtn: "联系我们",
    },
    ask: {
      title1: "开启专业可信的",
      title2: "精英教育导航",
      title3: "我们提供个性化需求定制：",
      title4: "专业监护计划",
      title5: "寄宿学校择校指导",
      title6: "全流程入学申请导航",
      title7: "（具体服务等级将在咨询后为您定制）",
      name: "您的姓名",
      namePlaceholder: "您的姓名",
      email: "邮箱地址",
      emailPlaceholder: "邮箱地址",
      phone: "联系电话",
      agePlaceholder: "您孩子的年龄",
      message: "留言",
      messagePlaceholder: "输入留言...",
      submit: "发送",
    },
    services: {
      title: "我们的服务",
      desc: "提供全方位的留学服务，从咨询到申请，从签证到监护，一站式解决你的留学需求",
      list: {
        consultation: {
          title: "留学咨询",
          desc: "专业顾问一对一咨询，为你制定个性化留学方案",
        },
        application: {
          title: "申请指导",
          desc: "全程指导申请流程，提高录取成功率",
        },
        visa: {
          title: "签证服务",
          desc: "专业签证指导，确保签证顺利通过",
        },
        guardianship: {
          title: "监护服务",
          desc: "海外监护服务，让家长放心，学生安心",
        },
      },
    },

    testimonials: {
      title: "客户感言",
      desc: "听听我们的客户怎么说",
      list: {
        item1: {
          content:
            "环球留学的服务非常专业，从咨询到申请全程都很顺利，最终成功拿到了心仪学校的offer。",
          name: "张同学",
          title: "美国加州大学伯克利分校",
        },
        item2: {
          content:
            "顾问老师很耐心，帮我分析了很多学校，最终选择了最适合的专业和学校。",
          name: "李同学",
          title: "英国伦敦政治经济学院",
        },
        item3: {
          content: "签证服务很到位，材料准备得很充分，一次就通过了。",
          name: "王同学",
          title: "加拿大多伦多大学",
        },
      },
    },
    stats: {
      students: "成功学生",
      countries: "覆盖国家",
      successRate: "成功率",
      years: "服务年限",
    },
  },
  footer: {
    shareSuccess: "链接已复制到剪贴板，快去分享给你的朋友吧",
    name1: "科博留学",
    name2: "科博留学剑桥监护中心",
    title: "保持联络",
    desc: "探索更多我们在社交媒体的内容",
    contact: {
      wechat: "微信",
      email: "邮箱",
      phone: "电话",
    },
  },
  services: {
    title: "服务项目",
    desc: "我们提供全方位的留学服务，从咨询到申请，从签证到监护，一站式解决你的留学需求",
    categories: {
      guardianship: "监护服务",
      hostFamily: "寄宿家庭",
      partnerSchools: "合作学校",
    },
    guardianship: {
      title: "监护服务",
      services: [
        {
          title: "金牌认证",
          title1: "监护服务",
          features: [
            // "学生在英期间的监护人，代表家长处理一切法律相关事务",
            "24小时紧急联系电话（当地时间 18:00-9:00 仅限于紧急情况）",
            "协助办理医疗注册与牙科预约",
            "与家长、学生和学校保持密切联系，通过加强双方的沟通来解决包括学生生病、学习困难、思乡等问题",
          ],
        },
        {
          title: "专业可信的",
          title1: "学业指导",
          features: [
            "建议和安排学生的假期课程",
            "每学期至少一次亲临学校探望学生，可以是出席家长会，或者专门安排的访问",
            "安排每学期中短假的可靠寄宿家庭，包三餐",
            "翻译学校成绩单，并和家长共同讨论学生学习上的进展和所遇到的问题",
          ],
        },
        {
          title: "透明可控",
          title1: "成长理财",
          features: [
            "翻译学校账单，并和学校确认学费支付情况",
            "协助家长管理学生的零用钱",
          ],
        },
        // {
        //   title: "",
        //   title1: "更多服务",
        //   features: [
        //     "安排“离校周末”期间（仅部分学校适用）的可靠寄宿家庭，包三餐",
        //     "按学校要求或家长要求，到学校看望学生",
        //     "据家长要求，新学校申请面试陪同",
        //     // "陪伴接送机",
        //   ],
        // },
      ],
    },
    hostFamily: {
      banner: {
        subtitle: "剑桥郡 / 伦敦 / 伊普斯威奇 ..",
        title: "学术氛围浓厚的英式家外之家",
      },
      garden: {
        title: "我们的寄宿家庭",
        highlight: "均符合 AEGIS 金牌标准",
        intro:
          "我们根据学生的学术需求、性格特点和饮食要求匹配寄宿家庭。所有寄宿家庭均符合以下严格标准：",
        features: {
          screening: {
            title: "筛选流程",
            items: [
              "DBS无犯罪认证 - 通过英国警方高级背景审查",
              "家居安全检查 - 由认证检查员进行年度审核",
              "丰富经验 - 至少3年国际学生接待经验",
            ],
          },
          environment: {
            title: "居住环境",
            items: [
              "邻近合作学校（如剑桥/伦敦/伊普斯威奇等）",
              "配备专用学习空间及无线网络",
              "完成跨文化沟通培训",
            ],
          },
          characteristics: {
            title: "家庭特点",
            items: [
              "多数为教育从业者或学校教职工",
              "部分掌握基础中文/粤语",
              "全员通过急救及儿童保护认证",
            ],
          },
        },
      },
      rooms: {
        livingroom: "客厅",
        bedroom: "卧室",
        garden: "花园",
      },
    },
    partnerSchools: {
      title: "合作学校",
      comingSoon: "详细内容即将上线，敬请期待...",
    },
    consultation: {
      title: "留学咨询",
      desc: "专业顾问一对一咨询，为你制定个性化留学方案",
      features: [
        "免费初步评估",
        "个性化留学规划",
        "学校专业选择建议",
        "申请时间规划",
      ],
      button: "立即咨询",
    },
    application: {
      title: "申请指导",
      desc: "全程指导申请流程，提高录取成功率",
      features: ["材料准备指导", "文书写作辅导", "申请表格填写", "面试培训"],
      button: "开始申请",
    },
    visa: {
      title: "签证服务",
      desc: "专业签证指导，确保签证顺利通过",
      features: ["签证材料准备", "面签培训", "签证申请指导", "后续跟进服务"],
      button: "签证咨询",
    },
    advantages: {
      title: "我们的优势",
      desc: "为什么选择我们",
      professional: {
        title: "专业团队",
        desc: "拥有多年留学申请经验的专业顾问团队",
      },
      experience: {
        title: "丰富经验",
        desc: "成功帮助数千名学生实现留学梦想",
      },
      service: {
        title: "优质服务",
        desc: "一对一专属服务，全程跟踪指导",
      },
      success: {
        title: "高成功率",
        desc: "98%的申请成功率，值得信赖",
      },
    },
  },
  about: {
    subTitle: "品牌故事",
    title: "科博留学剑桥监护中心",
    desc: "—留学英国的安心之选",
    desc2: "从伦敦国家医疗针灸师，到AEGIS金牌监护人，一位母亲的双文化守护哲学",
    company: {
      subTitle: "我们是谁",
      title: "荣获 AEGIS 金牌标准认证",
      desc: "国际学生教育与监护协会（AEGIS）授予金牌标准认证——这是监护机构能够获得的最高荣誉。AEGIS 会定期对其认可的监护人进行严格审查，确保所有机构始终符合“黄金标准”监护的严苛要求。",
      button: "查看认证",
    },
    service: {
      item1: {
        title: "核心项目",
        desc: "全部服务",
      },
      item2: {
        title: "学校申请服务",
        desc: "专注英国私立精英中小学申请",
        decs2: "提供专业择校指导与申请支持",
      },
      item3: {
        title: "短期体验项目",
        desc: "冬/夏令营课程与文化交流活动",
        decs2: "英国本地学校短期插班体验",
        decs3: "全面提升语言能力与跨文化沟通能力",
      },
    },
    //背景
    background: {
      title: "监护人背景",
      desc: "1991年至二女儿出生前，曾在伦敦NHS体系担任针灸师逾十年。期间通过个性化针灸治疗方案，帮助患者改善健康状况，提升生活质量。\n\n2003年二女儿出生后，为兼顾家庭，转型成为英国留学生监护顾问，主要服务来自中国的国际学生。这份工作远不止于行政事务——我致力于成为孩子们的导师与后盾，为他们提供学业指导、生活关怀与稳定的成长环境，帮助他们应对异国求学的种种挑战。\n\n这段事业与个人经历深刻共鸣。二十多岁时，我怀揣有限英语能力只身赴英，亲历过移民初期的迷茫。正因如此，我尤其理解年轻学子在异乡求学时面临的情感波动、文化适应与现实困境。\n\n作为AEGIS黄金认证会员（监护机构最高荣誉），始终以学生的福祉与成就为己任。这份资质不仅是对专业服务的肯定，更时刻提醒着我监护工作的深远意义。",
      desc2: "原NHS英国国家医疗服务体系针灸师",
      desc3: "定居英国三十余年",
      desc4: "教育监护服务专家",
      desc5: "科博留学剑桥监护中心创始人",
      button: "立即咨询",
    },
    history: {
      2001: {
        title: "2001 首例监护案例",
        desc: "第一次接触到海外留学服务。一位国内的朋友希望为她的两个儿子（9岁和15岁）寻找更好的教育机会，请我帮忙在英国找寄宿学校。我深入了解了英国的私立教育体系，成功为他们安排了合适的学校，并开始担任他们在英国的监护人。",
        images: ["2001.png"],
      },
      2002: {
        title: "2002 全职从事留学服务",
        desc: "在我的第二个女儿出生之后，我决定辞去伦敦NHS的工作，转为全职从事留学服务。从此，我开始专注为海外家庭提供专业的英国私校申请指导与学生监护服务。",
        images: ["2002.png"],
      },
      2017: {
        title: "2017 侄女剑桥大学经济系毕业",
        desc: "教育传承的力量，剑桥之旅点燃9岁侄女的学术梦想，我们用20年陪伴诠释：一次启蒙，终身成长。",
        images: ["2017.png"],
      },
      2023: {
        title: "2023 女儿牛津大学法律系毕业",
        desc: "女儿从牛津大学走向国际顶级律所的道路，不仅仅是学术上的成功，更是人格修养、领导才能与职业热情共同作用的结果。",
        images: ["2023.png"],
      },
      2024: {
        title: "2024 英国华人女性联盟杰出贡献奖",
        desc: "因在支持弱势家庭以及为来自战乱国家的难民提供免费专业服务等方面表现出的卓越奉献精神，荣获英国华人女性联合会（UKCWC）颁发的杰出贡献奖。",
        images: ["2024.png"],
      },
    },
  },
  contact: {
    title: "联系我们",
    desc: "有任何问题或需要咨询，请随时联系我们",
    phone: {
      title: "电话咨询",
      value: "400-123-4567",
      desc: "工作日 9:00-18:00",
    },
    email: {
      title: "邮件咨询",
      value: "info@globalstudy.com",
      desc: "24小时内回复",
    },
    address: {
      title: "公司地址",
      value: "北京市朝阳区建国门外大街1号",
      desc: "地铁1号线建国门站A出口",
    },
    hours: {
      title: "工作时间",
      value: "周一至周五 9:00-18:00",
      desc: "周六 9:00-17:00",
    },
    form: {
      title: "在线咨询",
      desc: "填写以下表单，我们的专业顾问将在24小时内与您联系",
      feature1: "免费初步评估",
      feature2: "个性化留学方案",
      feature3: "专业顾问一对一服务",
      name: "姓名",
      namePlaceholder: "请输入您的姓名",
      nameRequired: "请输入姓名",
      phone: "电话",
      phonePlaceholder: "请输入您的联系电话",
      phoneRequired: "请输入电话号码",
      email: "邮箱",
      emailPlaceholder: "请输入您的邮箱地址",
      emailRequired: "请输入邮箱地址",
      emailFormat: "请输入正确的邮箱格式",
      service: "服务类型",
      servicePlaceholder: "请选择您需要的服务",
      serviceRequired: "请选择服务类型",
      message: "留言",
      messagePlaceholder: "请详细描述您的需求",
      messageRequired: "请输入留言内容",
      submit: "提交咨询",
      success: "提交成功！我们将在24小时内与您联系",
      services: {
        consultation: "留学咨询",
        application: "申请指导",
        visa: "签证服务",
        guardianship: "监护服务",
        other: "其他服务",
      },
    },
    map: {
      placeholder: "地图加载中...",
    },
  },
  caring: {
    subTitle: "我们的服务",
    title: "悉心守护",
    description:
      "我们提供全方位的海外监护服务，从学业指导到生活照顾，从紧急响应到心理关怀，让每一位留学生都能在异国他乡感受到家的温暖。我们的监护团队由经验丰富的教育专家组成，确保学生在海外学习期间得到最好的照顾和支持。",
    button: "了解更多",
  },
  countries: {
    title: "留学国家",
    desc: "了解各个国家的留学特色和优势",
    viewMore: "了解更多",
    usa: {
      name: "美国留学",
      desc: "世界顶尖教育资源，多元文化环境，广阔的就业前景",
      feature1: "世界顶尖大学",
      feature2: "多元文化环境",
      feature3: "广阔的就业前景",
      feature4: "灵活的学制",
    },
    uk: {
      name: "英国留学",
      desc: "传统教育强国，学术氛围浓厚，学制紧凑高效",
      feature1: "传统教育强国",
      feature2: "学术氛围浓厚",
      feature3: "学制紧凑高效",
      feature4: "文化底蕴深厚",
    },
    canada: {
      name: "加拿大留学",
      desc: "安全宜居的环境，优质的教育资源，友好的移民政策",
      feature1: "安全宜居环境",
      feature2: "优质教育资源",
      feature3: "友好移民政策",
      feature4: "多元包容社会",
    },
    australia: {
      name: "澳大利亚留学",
      desc: "阳光明媚的气候，高质量的教育，舒适的生活环境",
      feature1: "阳光明媚气候",
      feature2: "高质量教育",
      feature3: "舒适生活环境",
      feature4: "宽松签证政策",
    },
  },
  news: {
    title: "新闻资讯",
    desc: "了解最新的留学资讯和政策动态",
    readMore: "阅读更多",
    categories: {
      visa: "签证政策",
      application: "申请指南",
      school: "学校介绍",
      life: "留学生活",
    },
    articles: {
      article1: {
        title: "2024年美国留学签证政策最新变化",
        desc: "了解最新的美国留学签证申请要求和注意事项",
      },
      article2: {
        title: "英国大学申请时间规划指南",
        desc: "详细的英国大学申请时间安排和材料准备建议",
      },
      article3: {
        title: "加拿大顶尖大学介绍",
        desc: "深入了解加拿大知名大学的特色专业和申请要求",
      },
      article4: {
        title: "澳大利亚留学生活指南",
        desc: "实用的澳大利亚留学生活建议和注意事项",
      },
    },
  },
  testimonials: {
    subTitle: "客户感言",
    title: "我们的客户是怎么",
    title2: "评价我们的",
    title1: "",
    desc: "来自真实客户的反馈",
    list: {
      item1: {
        content:
          "Clare好！\n\n回望孩子在您监护下的岁月，心中满是感激和钦佩，都说“儿行千里母担忧”，幸而有您的专业和热心，支持她适应异域环境，帮助她克服生活困难，指导她规划深造之路，促进她顺利考入心仪的大学。\n\n记得疫情期间，她无论在往返中英、学习秩序还是假期生活上都遭遇一系列的困难，而您总是当机立断、不顾安危、东奔西走协助处理，带着孩子一会穿越城市加急办理BRP卡，一会赴医院进行病情诊断，一会协调当地的寄宿……疫情三年，正在您的呵护下，孩子身心健康，学业顺利，获得了良好的成长环境。\n\n在成长教育上，您的干练、大方、雅致等为她做出优秀的榜样。您时常邀请她赴家中小憩，期间，细到怎样叠衣服、怎样理行李、怎样做饭菜？您都会手把手地教她独立生活的技能；同时还通过身边具体的事情，教导孩子要学会独立思考、勤俭持家和勇争上游，平等、坦率又不失权威的沟通甚于我们亲身父母。\n\n我们非常珍惜与您因孩子而结下的缘分，孩子念大学后，您继续给她细致的关心和帮助，特别是向她提供人生的建议，令我们颇感温暖，愿我们的友谊地久天长。 沈俊（沈宜父亲）",
        name: "沈宜父亲",
        title: "家长",
        school:
          "其女儿曾就读于Woodbridge School，目前就读于爱丁堡大学经济专业。",
      },
      item2: {
        content:
          "亲爱的Clare ：\n展信悦！\n今天有个朋友在咨询女儿出国的经历时，不由自主的谈到了您，问及您是怎样一个监护人时，我竟一时语塞，不知如何作答。朋友、母亲、老师，心理医生，知书达礼，温文尔雅......凡此种种不一而足。\n\n当年为了给女儿提供一个充满选择和可能性的未来，我们把12岁的女儿送到了英国求学。清楚的记得第一次见面时您把我们直接接回了家里，并准备了一桌丰盛的晚餐，一句“我们王家的女儿来了”，瞬间就让我们和孩子对未知的迷茫减轻了许多。\n\n是您耐心地陪着女儿度过人生中最重要的青春期阶段，同时让我们纵然远隔重洋都能随时见证她的成长和进步；是您想方设法地让女儿平稳地度过了初到异乡的心理以及生理的不适期，之后又鼓励和支持她选择了更好的学校；正是您的关爱和陪伴，女儿成长成为了一个有温度懂情趣会思考的人，学会了爱自己保护自己，也是您的言传身教，女儿明白了被需要、帮助别人是一件幸福的事情，懂得了怎么做一个有原则并且善良的女性...一切种种，汇集两字：感恩！\n\n我们非常欣慰的听到，女儿告诉我们，她想成为您这样的女性：拥有怜悯之心、助人之手、宽容之怀，美丽、自信和优雅，内心强大。\n\n以上啰嗦了这许多，却总觉得也还没说明白。但有一点可以明确的是：非常荣幸能有您这样的朋友，感恩您对我们所有的付出，我们也会将这份感恩传递。\n\n另：非常高兴的告诉您，女儿今年的已经顺利从本科毕业，并拿到帝国理工学院研究生offer.\n\n顺颂时祺！秋绥冬禧！\n\n好友：王强、许菁",
        name: "Victoria  王馨桎家长",
        title: "家长",
        school:
          "其女儿曾就读于St Mary's School Cambridge，毕业于帝国理工学院生物化学专业，现已获得研究生录取通知书。",
      },
      item3: {
        content:
          "Clare是一位非常负责任且高效的学生监护人。在我儿子面临学校选择的重要时刻，她以专业的判断力和丰富的经验，给予了我们极具价值的建议，帮助我儿子顺利找到适合他的学校，让他重新建立起信心，走出了低谷。\n\n不仅如此，Clare 在整个过程中始终用心陪伴，不仅是孩子的支持者，也成为我的好朋友，她给了我太多细致入微的帮助，她的专业能力与真诚关怀，让人感到非常安心与信任。\n\n我衷心推荐Clare,她不仅是孩子成长路上的良师，更是家长可以全心依靠的伙伴。",
        name: "王晟羽母亲",
        title: "学生",
        school:
          "其儿子曾在King's School Ely就读，后毕业于伦敦艺术学院，现任上市公司日播时尚集团董事长。",
      },
      item4: {
        content:
          "“她的成长与您紧密相连。您见证了她每一次的进步与蜕变，所以这份喜悦怎能少了您的参与？其实对您的感谢，我一直放在心里，但今天仍想对您说：您的护女之恩，暖心之情，我们铭记于心。感谢您一路的陪伴与支持，让她在这片陌生的土地上始终有依靠。”",
        name: "Helen 钟一鸣母亲",
        title: "家长",
        school: "其女儿曾就读于New Hall School，毕业于伦敦帝国理工学院。",
      },
      item5: {
        content:
          "还记得二年前，我心急如焚地向您求助当时女儿在杭州完全丧失学习动力，甚至被学校劝退。看着她整日消沉、眼神黯淡，作为父母的我们束手无策，只盼她能重拾快乐，学业反倒成了其次。把孩子托付给远在英国的您，是我们当时最后的希望。没想到短短二年过去，她竟发生了翻天覆地的变化！如今的她眼里闪着自信的光芒，整个人开朗又快乐，更让我们惊喜的是，她开始主动规划学业，对未来充满热情。这份蜕变远超我们的预期，我们全家实在不知如何表达这份感激！千言万语化作一句：真的太感谢您了！\n\n非常感谢王姐这几年对我女儿钱汐无微不至的关怀与照顾！孩子初到英国，面对陌生的环境和文化差异，难免感到不安与迷茫。从一日三餐到日常起居都安排得井井有条，让孩子有回家的感觉，还在学习和心理方面给予了专业且温暖的引导。当孩子遇到学业难题时，王姐会耐心地帮忙分析、寻找解决办法；在她情绪低落时，又像家人般倾听她的烦恼，给予鼓励和安慰。在王姐的呵护下，孩子快速适应了英国的学习生活，性格也愈发开朗自信。真的非常感激王姐这份超越职责的关爱，让远在国内的我们倍感安心！",
        name: "Aurora 钱夕父母",
        title: "家长",
        school: "其女儿现就读于RGS Surrey Hill。",
      },
      item6: {
        content:
          "作为家长，我们由衷感谢您这一年来作为孩子在英监护人的全心付出。您细致专业的照料让我们倍感安心——无论是日常生活关怀还是学业规划，您展现的教育智慧始终令人叹服。从课程选择到学习节奏调整，您量身定制的建议帮助丹尼尔找准方向并稳步进步。这一年里，他不仅学业精进，更培养了独立思考与自律能力，获得校方嘉许——这一切都印证了您教导的成效。\n您早已超越监护人的角色，是引领他适应文化差异、克服成长挑战的良师益友。这份温暖与支持，我们全家铭记于心。诚挚期待未来继续携手同行！",
        name: "Daniel 朱俊熙父母",
        title: "家长",
        school: "其儿子现就读于Royal Hospital School。",
      },
      item7: {
        content:
          "我是来自中国广东的家长，是改革开放起步发展最前列的省份。为了下一代的教育，培养成为具有国际视野的人才，我的女儿于2001 年经深圳爱子留学咨询服务中心推荐，前往英国留学。2008 年女儿获得硕士学位毕业于英国伦敦经济政治学院。\n\n女儿留学期间，我将年仅十七岁的小儿再次经爱子留学咨询服务中心推荐，并为我们选择了王老师作为小儿在英国留学的监护人。\n\n尊敬的王老師當年給予我儿子無微不至的照顧和悉心教導，让我们远在中国的父母得以安心工作、放心儿子在英国的生活与学习。\n\n记得当年我们夫妇圣诞节前从中国飞往英国伦敦，参加女儿在伦敦经济政治学院的研究生毕业典礼，接着带同女儿我们仨人乘坐火车，前往剑桥探望小儿，大雪影响了火车的准点到达，而监护人王老师耐心等待我们的火车慢点了2 个小时，并热情洋溢接待我們家長的到來，陪同校長一起，向我們家長匯報孩子一年来的學習情況，贊揚兒子的品学兼优。\n\n王老師在我儿子以及家長的心目中是一位優雅知性、有責任心更在愛心的监护人。\n\n因为圣诞节前下着大雪，交通不便利，王老师招待我们在她家里住了一个晚上。真的让我们感到无比的荣幸和温暖。\n\n王老师就是这么一个既有才华、学问、又有责任心和爱心的好老师，她才华横溢、学问渊博、品味高雅、待人真诚善良和蔼可亲，能遇见王老师成为我儿子的监护人是我小儿的福气，是我们一辈子难忘的好朋友！\n\n喜闻王老师来中国深圳，我们全家喜出望外专程去深圳与王老师相聚！\n\n十年后的2019 年，我们全家（这次带上我的外孙儿外孙女、女婿、未来媳妇）去瑞士旅游专程转飞英国重游故地再次拜访王老师，作客于贵府受到王老师的热情款待，王老师亲自为我们做了精致美味的蛋糕和食物，还赠送了贵重的礼物给我们作留念，让我们全家再度留下美好的回忆！\n\n儿子的大学选择在加拿大Kwantlen Polytechnic University，毕业后如今儿子成家了，定居于加拿大温哥华！感谢在他人生路上青少年成长过程的重要时期，遇到王老师这样好的良师益友。\n\n藉此表达我作为家长以及我的家人们对王老師的衷心感激和祝福！",
        name: "Jefferson 苏家健母亲",
        title: "家长",
        school: "其儿子曾就读于Bedford School，毕业于加拿大昆特兰理工大学（Kwantlen Polytechnic University）。",
      },
      item8: {
        content:
          "在我的身邊 有這樣一位優秀的監護人\n她是一個懂得尊重孩子 呵護孩子 引導孩子自主成長的人\n她就是 Clare Wang\n2018年的復活節經朋友介紹我們認識了 短短一個多小時的聊天就让我決定讓兒子去英國留學并且讓這位Clare做兒子的監護人 當年九月Clare安排好英國的學校 兒子就這樣順利的去了英國留學\n作為一個監護人 快二十年的教育事業讓Clare有著丰富的經驗 更是懂得教育的好母親 她自己的大女兒以優異的成績也順利考進牛津大學 她非常尊重孩子的選擇和決定 給予他們足夠的自主空間 還會給予孩子足夠的關愛和鼓勵 她總是在孩子們困難的時候 給予堅定的支持 讓孩子們相信自己能克服困難 獲得好成績 這麼多年來成就了太多的優秀孩子\n很幸運作為帝國理工的家長 我非常敬佩Clare Wang 同時也非常感謝與感恩Clare這幾年對兒子的幫助與鼓勵 選擇一個優秀的監護人很重要[爱心][爱心]",
        name: "Roy 刘之鸣母亲",
        title: "家长",
        school: "其儿子曾就读Moreton Hall，现为帝国理工学院学生。",
      },
      item9: {
        content:
          "2010年，女儿将独自一人前往英国求学，由于年龄关系需要找一位法定监护人，通过介绍我们认识了王老师。\n   初次见面对王老师感到特别的亲切，而她热情大方，温暖热情的语调感染到我们，深感女儿将面对陌生的语言环境和文化背景，远离家乡、亲人，心中难免惶恐和不安，由她担任女儿的法定监护人我们由衷的感到放心。\n    在接下来的2年中，王老师不仅仅是履行职责的监护人，更像是一位亲人，给予了女儿全面而细致的照顾与引导。无论是在学业上还是在生活中，她都始终保持着高度的责任感与耐心。每逢学校重大事件，家长会内容及放假等安排她都会第一时间与我们沟通，让我们及时了解女儿在英国的学习和生活状况。\n    王老师的专业、细致与真诚，不仅赢得了我们全家人的高度信任，也让女儿在一个良好、稳定的环境中顺利完成了学业。王老师对未成年留学生的理解和支持，从一个稚嫩的孩子逐步成长为可以独立面对世界的年轻人。\n  时至今日，我依然感恩当初能够遇见王老师，并有幸成为了好朋友，由衷地向所有需要在英国寻找监护人的学生与家长推荐她。王老师不仅是一位值得信赖的监护人，更是一位真正理解学生、关心学生成长的良师益友。",
        name: "Lynna 朗筱煜母亲",
        title: "家长",
        school:
          "其女儿毕业于Culford School和UCL伦敦大学学院，目前担任上海某国际学校学术校长。",
      },
      item10: {
        content:
          "致Clare：十年守护，一生感恩\n\n时光飞逝，转眼间我的女儿和儿子在英国求学毕业已愈8年，2006年，当13岁的女儿初次踏上异国的土地，是您——王老师，永远记得初次见到你的样子，一头齐耳短发，笑容明媚，一口洁白的牙齿，温暖又愉快的声音瞬间让你感到很亲切。你用温暖的双手和无私的关怀，为她撑起了一片天空。从最初的监护人，到后来儿子也加入这个“家”，您不仅给予了孩子们生活上的悉心照料，更在成长的每一个关键阶段，用智慧和爱心引导他们。  \n\n作为父母，我们深知海外留学的艰辛。语言、文化、学业的压力，以及青春期的迷茫，都曾让孩子们倍感挑战。但因为有您的存在，他们从未感到孤单。您像一位贴心的长辈，教会他们独立与坚韧；也像一位真诚的朋友，倾听他们的烦恼与喜悦。您不仅关注他们的学业成绩，更重视他们的品格培养与心理健康。正是您的言传身教，让孩子们在异国他乡依然能自信成长，成为今天的模样。  \n\n十年光阴，我们从最初的委托关系，逐渐成为彼此信任的朋友。这份情谊，早已超越了职责本身。您对孩子们的付出，我们铭记于心；而您对我们的理解与支持，更让我们感动不已。  \n\n千言万语，难表谢意。愿未来的日子里，我们依然能携手同行，虽然孩子们已经踏入社会，已经有了家庭和孩子，但是我们依然分享孩子们的生活和工作，分享我们生活的日常，您不仅是他们人生中重要的引路人，也是我们全家永远珍惜的挚友。  \n\n衷心感谢您十年如一日的守护！  \n您的好友 吳思媽媽Jennifer ，吳思同學就讀Bedford school, UCL大學畢業",
        name: "Cornelia 吴思妈妈",
        title: "家长",
        school: "其女儿毕业于Bedford School，后在伦敦大学学院(UCL)完成大学学业。",
      },
      item11: {
        content:
          "自2005年王老师成为我孩子的监护人起，我便立刻感受到她对待工作的满腔热忱。这些年来，我们的关系已从单纯的业务往来发展为真挚的友谊——因为对王老师而言，监护绝非仅是职业，而是倾注全部心力呵护每个孩子的成长旅程。\n\n在我孩子的留学岁月里，王老师始终将他的真实感受与志向放在首位，全力支持他实现目标，让他在成长关键期获得真正的成就感。超越普通监护人的职责，王老师在异国扮演了母亲般的角色：给予激励、引导正确抉择，提供唯有至亲才能给予的关爱与指引——这正是她堪称「钻石级监护人」的缘由！",
        name: "William 付浩玮父亲",
        title: "家长",
        school: "其儿子曾就读于Oundle School，毕业于帝国理工学院。",
      },
      item12: {
        content:
          "王老师一直保持家校的紧密沟通，不仅及时反馈孩子的学习情况，更是时刻关心孩子的行为规范和心理健康，除了履行监护义务，还经常邀请孩子到家中团聚，这些温暖的举动让孩子真正感受到在异国他乡的归属感。  她不仅是孩子成长道路上的良师益友，还是我们家长最坚实的后盾！",
        name: "Iven 张王栋母亲",
        title: "家长",
        school: "其儿子就读于Vinehall School。",
      },
      item13: {
        content:
          "感恩王老师：我们全家都对王老师怀有深深的感激之情。她为我们女儿 Nina 牵线搭桥，介绍了一所对她而言堪称完美的学校。这两年她从一个懵懂的孩子成长为一个各方面都出类拔萃的少女。\n过去两年里她变得懂礼貌、知尊重和体谅，这让我们家长感到非常欣慰。曾经需要我们督促才能学习的她，现在完全是自动自发地学习。她对知识充满了渴望，不仅满足于课堂内容，更会主动探索，要求假期安排补习、对自己有很高的要求。Nina 变得更有抱负，并且敢于追求自己的目标，她变得自信、乐观和开朗，她的学习成绩突飞猛进。\n除了为 Nina 选择合适的学校，王老师在日常的关心和帮助更是无微不至，让我们由衷感到安心。只要孩子有任何事情，无论是学业上的困惑还是生活上的小插曲，王老师总是第一时间主动与我们沟通，并迅速协调解决，从不让我们操心。她的效率和责任感让我们非常感恩。将孩子交给王老师，我们感到前所未有的放心和安心。我们相信，在王老师的悉心教导和关怀下，Nina 的未来一定会更加光明。",
        name: "Nina 吴念茬母亲",
        title: "学生",
        school: "其女儿就读于St Edmund’s College。",
      },
      item14: {
        content:
          "我非常感谢我孩子的监护人Clare老师。她会定期前往学校探望孩子，细心了解她的学习和生活状况，还在假期里根据孩子的性格特点精心安排合适的寄宿家庭，并亲自前往探访，确保孩子住得安心、舒适。遇到中国传统节日如春节、端午、中秋等，她更是主动邀请孩子到自己家中团聚，让孩子在异国他乡感受到温暖和归属。每次与孩子见面，她都用轻松的方式与她交谈，循循善诱地引导孩子更好地适应当地生活，同时鼓励她保持善良本性、乐于助人。把孩子交给 Clare老师，我们家长真的感到非常放心。",
        name: "Alex 李米妈妈",
        title: "家长",
        school: "其女儿就读于St Edmund's College，顺利进入剑桥大学自然科学专业。",
      },
      item15: {
        content:
          "Clare在英国陪伴我的整个过程中，都展现出了无微不至的关怀。她定期来学校探望我，让我时刻感受到被支持与被关爱。在学业规划上，她给予了我至关重要的指导——包括根据我的特长和目标，帮助我选择最适合的学校。她的建议总是既周到又充满鼓励，并且会花时间真正了解我的兴趣与志向。\n在期中假期时，我们常在剑桥共度时光，她总会准备可口的中餐，让我们感受到家的温暖。她的贴心、支持与全心付出，为我营造了一个安心的成长环境，帮助我在异国他乡顺利适应并取得成功。",
        name: "学生 Tracy 王卉",
        title: "学生",
        school:
          "Tracy 曾在St Edmunds College求学，后于Exeter大学完成本科和研究生学业，目前在加拿大多伦多一所国际学校担任教师。",
      },
    },
  },
  policies: {
    title: "我们的政策",
    privacy: "隐私政策",
    privacyContent: {
      whoWeAre: {
        title: "我们是谁",
        content: "我们的网站地址是：https://hopeguardianship.net",
      },
      comments: {
        title: "评论",
        content:
          "当访客在网站上发表评论时，我们会收集评论表单中的数据、访客的IP地址及浏览器代理信息，以帮助识别垃圾评论。<br><br>您的电子邮件地址可能会被转换为匿名哈希值并提交至Gravatar服务，以确认您是否使用该服务。我们的隐私政策请见：https://hopeguardianship.net/policies。您的评论一经批准，您的头像将公开显示在评论旁。",
      },
      media: {
        title: "媒体",
        content:
          "如果您上传图片至网站，请避免包含内嵌的位置数据（如EXIF GPS）。访客可下载并提取网站图片中的位置信息。",
      },
      cookies: {
        title: "Cookies",
        content:
          "若您在本站发表评论，可选择保存您的姓名、邮箱和网站在Cookies中，以便下次评论时无需重复填写。此类Cookies将保留1年。<br><br>访问登录页面时，我们会设置临时Cookie以检测浏览器是否接受Cookies。此Cookie不包含个人数据，关闭浏览器后即失效。<br><br>登录后，我们会设置多个Cookies以保存登录信息及屏幕显示选项。登录Cookies保留2天，屏幕选项Cookies保留1年。若选择“记住我”，登录状态将保持2周。退出登录后，登录Cookies将被移除。<br><br>编辑或发布文章时，浏览器会保存额外Cookie，仅包含文章ID，1天后过期。",
      },
      embeddedContent: {
        title: "其他网站的嵌入内容",
        content:
          "本网站文章可能包含嵌入内容（如视频、图片、文章等）。这些内容的表现形式与访客直接访问原网站无异。<br><br>这些网站可能会收集您的数据、使用Cookies、嵌入第三方跟踪代码，并监控您与嵌入内容的互动（如您已登录该网站）。",
      },
      dataSharing: {
        title: "数据共享",
        content: "若您申请重置密码，您的IP地址将包含在重置邮件中。",
      },
      dataRetention: {
        title: "数据保留期限",
        content:
          "评论及其元数据将被无限期保留，以便自动识别并批准后续评论，而无需人工审核。<br><br>注册用户的信息将存储于个人资料中，用户可随时查看、编辑或删除（用户名除外）。网站管理员也可查看及编辑这些信息。",
      },
      dataRights: {
        title: "您的数据权利",
        content:
          "您可请求导出我们持有的您的个人数据（包括已提交的数据），或要求删除这些数据。但出于行政、法律或安全需要保留的数据除外。",
      },
      dataDestination: {
        title: "数据去向",
        content: "访客评论可能通过自动化垃圾检测服务进行筛查。",
      },
    },
  },
  parents: {
    title: "家长专区",
    desc: "为家长提供专业的留学咨询和服务",
    learnMore: "了解更多",
    services: {
      service1: {
        title: "申请指导",
        desc: "专业的申请材料准备和提交指导，确保申请成功率",
      },
      service2: {
        title: "咨询服务",
        desc: "一对一专业咨询，解答家长和学生的各种疑问",
      },
      service3: {
        title: "签证辅导",
        desc: "详细的签证申请指导和面试培训",
      },
      service4: {
        title: "费用规划",
        desc: "合理的留学费用规划和奖学金申请指导",
      },
    },

    faq: {
      title: "常见问题",
      list: {
        item1: {
          number: "01",
          question: "我的孩子几岁可以申请英国私立学校？",
          answer:
            "通常，英国私立学校接收从7岁到18岁的学生。根据孩子的英语水平和学术能力，我们会协助推荐适合的入学年级与学校类型。",
        },
        item2: {
          number: "02",
          question: "学校申请流程是怎样的？",
          answer:
            "我们会协助家长完成以下流程：初步评估 → 学校筛选与推荐 → 材料准备 → 提交申请 → 面试与考试准备 → 录取与注册 → 安排监护人及住宿。",
        },
        item3: {
          number: "03",
          question: "如果孩子英语不好，还可以申请吗？",
          answer:
            "可以。许多学校提供EAL（英语作为附加语言）支持课程。学生也可选择在进入主流学校前，先入读专门的预科学习中心。",
        },
        item4: {
          number: "04",
          question: "什么是监护人服务？为什么必须要有监护人？",
          answer:
            "英国法律规定18岁以下的国际学生在就读期间必须有本地监护人。监护人负责在紧急情况下做决策、假期安排、与学校沟通等。我们提供注册监护人服务，确保学生在英期间安全、安心、受关爱。",
        },
        item5: {
          number: "05",
          question: "放假期间孩子可以回国吗？",
          answer:
            "可以。我们会协助安排机票、签证以及学校放假时的行程。若选择留在英国，也可安排寄宿家庭或假期住宿。",
        },
        item6: {
          number: "06",
          question: "您的监护服务有哪些特色？",
          answer:
            "我们拥有超过20年经验，以“像母亲一样”的关怀陪伴每一位学生成长。服务包括：定期探访、24小时应急联络、学业关注、假期安排、心理支持、与家校之间的沟通协调等。",
        },
        item7: {
          number: "07",
          question: "可以只做学校申请，不要监护服务吗？",
          answer:
            "当然可以。我们提供灵活的服务模式，家长可以根据实际需求选择只做申请、只做监护，或两者都选择。",
        },
        item8: {
          number: "08",
          question: "我们已经自己申请好学校了，可以只委托您做监护吗？",
          answer:
            "当然可以。很多家庭已自行完成申请，我们可以单独提供专业的监护服务，确保孩子在英国期间安全、顺利、得到及时支持。",
        },
      },
    },
  },
};
